import { render, staticRenderFns } from "./indexPlat.vue?vue&type=template&id=c402a41a"
import script from "./indexPlat.vue?vue&type=script&lang=js"
export * from "./indexPlat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports